import { connect } from 'react-redux';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import {
  applyWhatIf,
  fetchWhatIfOptions,
  initialPlanImpact,
  planImpact,
  updateWhatIfsData,
} from '../../WhatIfsActions';
import RouteDictionary from '../../WhatIfsRouteDictionary';
import {
  areOptionsLoaded,
  impactSelector,
  loading,
  nullableFpIdSelector,
  nullableGroupTitleSelector,
  nullableTitleSelector,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
} from '../../WhatIfsSelector';
import {
  dafDonationEndYearSelector,
  dafDonationStartYearSelector,
  dafEndYearOptionsSelector,
  dafGrantEndYearSelector,
  dafGrantStartYearSelector,
  dafStartYearOptionsSelector,
  donationEndYearSelector,
  donationStartYearSelector,
  isRecurringSelector,
  yearsOptionsSelector,
} from './DonationYearSelector';
import View from './DonationYearView';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  loading: loading(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  yearsOptions: yearsOptionsSelector(state, ownProps),
  dafStartYearOptions: dafStartYearOptionsSelector(state, ownProps),
  dafEndYearOptions: dafEndYearOptionsSelector(state, ownProps),
  donationEndYear: donationEndYearSelector(state, ownProps),
  donationStartYear: donationStartYearSelector(state, ownProps),
  isRecurring: isRecurringSelector(state, ownProps),
  dafDonationStartYear: dafDonationStartYearSelector(state, ownProps),
  dafDonationEndYear: dafDonationEndYearSelector(state, ownProps),
  dafGrantStartYear: dafGrantStartYearSelector(state, ownProps),
  dafGrantEndYear: dafGrantEndYearSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  onYearChange: (clientId, goalId, whatIfType, field, selectedOption) => {
    if (selectedOption) {
      let valueToSend;
      if (
        field === 'DafDonationStartYear' ||
        field === 'DafDonationEndYear' ||
        field === 'DafGrantStartYear' ||
        field === 'DafGrantEndYear'
      ) {
        valueToSend = { Year: selectedOption.value, Type: selectedOption.type };
      } else {
        valueToSend = selectedOption.value; // For normal donation years
      }

      dispatch(
        updateWhatIfsData(clientId, goalId, whatIfType, { WhatIf: { [field]: valueToSend } }),
      );
    }
  },

  storeData: (goalId, whatIfType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      initialPlanImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchData: (clientId, fpId, goalId, whatIfType) => {
    dispatch(fetchWhatIfOptions(clientId, fpId, goalId, RouteDictionary[whatIfType], whatIfType));
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(
      applyWhatIf(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
